export const label = {
  'fr-CA': 'Pause',
  'nl-NL': 'Pauzeren',
  'zh-TW': '暫停',
  ar: 'إيقاف مؤقت',
  az: 'Fasilə',
  be: 'Паўза',
  bg: 'Пауза',
  bs: 'Pauza',
  cnr: 'Pauza',
  cs: 'Pozastavit',
  da: 'Pause',
  de: 'Pause',
  el: 'Παύση',
  en: 'Pause',
  es: 'Pausa',
  et: 'Paus',
  fi: 'Keskeytä',
  fr: 'Pause',
  he: 'השהה',
  hr: 'Pauziraj',
  hu: 'Szüneteltetés',
  hy: 'Դադար',
  id: 'Jeda',
  is: 'Hlé',
  it: 'Pausa',
  ja: '一時停止',
  ka: 'პაუზა',
  ko: '일시 정지',
  lt: 'Pristabdyti',
  lv: 'Pauze',
  mk: 'Пауза',
  nl: 'Pauzeren',
  no: 'Pause',
  pl: 'Wstrzymaj',
  pt: 'Pausa',
  ro: 'Pauză',
  ru: 'Пауза',
  sk: 'Pozastaviť',
  sl: 'Premor',
  sq: 'Pauzë',
  sr: 'Pauza',
  sv: 'Paus',
  th: 'หยุดชั่วคราว',
  tr: 'Duraklat',
  uk: 'Пауза',
  vi: 'Tạm dừng',
  zh: '暂停',
};
